import { render, staticRenderFns } from "./addrmanage.vue?vue&type=template&id=a9e46ae4&scoped=true&"
import script from "./addrmanage.vue?vue&type=script&lang=js&"
export * from "./addrmanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e46ae4",
  null
  
)

export default component.exports